module.exports = __webpack_public_path__ + "static/media/22-007.f106a431.png";